function truncate(str, maxLength){
 if (!str) return "";
  return str.length > maxLength ? str.substring(0, maxLength) + "..." : str;
}
export default truncate;